<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <img-with-loading
    :height="'36px'"
    :img-src="getImageSrc()"
    :width="'36px'"
  />
</template>

<script>
import ImgWithLoading from './ImgWithLoading.vue'

export default {
  name: 'ImgTemplate',
  components: { ImgWithLoading },
  props: {
    root: {
      type: String,
      default: '/'
    },
    item: {
      type: Object,
      default: null
    },
    model: {
      type: String,
      default: 'photo'
    }
  },
  methods: {
    getImageSrc () {
      if (!this.item || !this.item[this.model]) {
        return ''
      }

      const imagePath = this.item[this.model]

      // Handle File or Blob objects
      if (imagePath instanceof File || imagePath instanceof Blob) {
        return URL.createObjectURL(imagePath)
      }

      // Handle string paths
      if (typeof imagePath === 'string') {
        // If it's already a full URL or data URL, return it as is
        if (imagePath.startsWith('http') ||
            imagePath.startsWith('https') ||
            imagePath.startsWith('data:') ||
            imagePath.startsWith('blob:')) {
          return imagePath
        }

        // If it already starts with the root path, return it as is
        if (imagePath.startsWith(this.root)) {
          return imagePath
        }

        // Otherwise, concatenate root and image path
        return this.root + imagePath
      }

      return ''
    }
  }
}
</script>

<style scoped>

</style>
